<template>
  <div class="session-logs">
    <div class="title">Session <span>Logs</span></div>
    <div class="filters">
      <vi-date-picker v-model="filters.fromDate" placeholder="Date from"/>
      <vi-date-picker v-model="filters.toDate" placeholder="Date to"/>
<!--      <contact-picker v-model="filters.contactId"/>-->
      <vi-button label="Generate" @click="search"/>
    </div>
    <div v-infinite-scroll="loadMore" :infinite-scroll-disabled="isLoading || disableLoadMore">
      <table v-if="sessionLogs.length">
        <thead>
          <tr>
            <th @click="sortBy('initiatedAt')">
              <div class="sortable" :class="{active: isActiveSort('initiatedAt')}">
                Start time
                <div class="sort-icon">
                  <fa-icon icon="chevron-down" v-if="isSortDesc('initiatedAt')"/>
                  <fa-icon icon="chevron-up" v-else/>
                </div>
              </div>
            </th>
            <th>End time</th>
            <th @click="sortBy('duration')">
              <div class="sortable" :class="{active: isActiveSort('duration')}">
                Duration
                <div class="sort-icon">
                  <fa-icon icon="chevron-down" v-if="isSortDesc('duration')"/>
                  <fa-icon icon="chevron-up" v-else/>
                </div>
              </div>
            </th>
            <th>Customer IP Address</th>
            <th>Contact</th>
            <th>Customer Device</th>
            <th>Call Details</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="log in sessionLogs">
          <td>{{formatDate(log.initiatedAt)}}</td>
          <td>{{formatDate(log.endedAt)}}</td>
          <td>{{duration(log)}}</td>
          <td>{{log.customerIpAddress}}</td>
          <td>{{log.contact? log.contact.name: ''}}</td>
          <td>{{getLogPlatform(log.platform)}}</td>
          <td>
            <div @click="openCallDetailsPreview(log)" v-tooltip="'Call Details'">
              <img src="../assets/icon_call_details_v2.svg" style="height: 26px; cursor: pointer;"/>
            </div>
<!--            <session-recording :session-log="log" @openScreenshotsPreview="openScreenshotsPreview(log)" @openNotesPreview="openNotesPreview(log)"/>-->
          </td>
        </tr>
        </tbody>
      </table>
      <div class="no-results" v-if="noResultsFound && !filtersError">No logs to display for the selected dates.</div>
      <div class="no-results error" v-if="filtersError">The 'To' date cannot be before the 'From' date. </div>
    </div>
<!--    <screenshots-preview :session-log="currentScreenshotsSessionLog" @close="closeScreenshotsPreview"/>-->
<!--    <notes-preview :session-log="currentNotesSessionLog" @close="closeNotesPreview" />-->
    <call-details :session-log="currentSessionCallDetails"  @close="closeCurrentSessionCallDetailsPreview" />
    <div class="back-button" v-if="backEnabled" @click="goBack">
      <fa-icon icon="chevron-left"/>
      <div>Back</div>
    </div>
  </div>
</template>

<script>
  import ViInput from "../components/ui/ViInput";
  import ViButton from "../components/ui/ViButton";
  import {mapState} from 'vuex';
  import {format, differenceInSeconds, setHours, setSeconds, setMinutes, subWeeks} from 'date-fns';
  import infiniteScroll from 'vue-infinite-scroll'
  import ViDatePicker from "../components/ui/ViDatePicker";
  import ContactPicker from "../components/contacts/ContactPicker";
  import SessionRecording from "../components/sessions/SessionRecording";
  import ScreenshotsPreview from "../components/screenshots/ScreenshotsPreview";
  import NotesPreview from "../components/notes/NotesPreview";
  import CallDetails from "../components/call/CallDetails";

  export default {
    components: {
      CallDetails,
      NotesPreview, ScreenshotsPreview, SessionRecording, ContactPicker, ViDatePicker, ViButton, ViInput},
    directives: {infiniteScroll},

    props: {
      contact: {
        type: Object
      },
      backEnabled: {
        type: Boolean
      }
    },

    data: () => ({
      filters: {
        limit: 20,
        offset: 0,
        fromDate: subWeeks(new Date, 1),
        toDate: new Date,
        contactId: null,
        order: ['initiatedAt', 'DESC']
      },
      isLoading: false,
      disableLoadMore: false,
      noResultsFound: false,
      filtersError: false,
      currentScreenshotsSessionLog: null,
      currentNotesSessionLog: null,
      currentSessionCallDetails: null,
    }),

    computed: {
      ...mapState({
        sessionLogs: state => state.sessions.list
      })
    },

    methods: {

      goBack() {
        this.$emit('back')
      },

      formatDate(date) {
        return date? format(parseInt(date), 'MMM DD YYYY HH:mm:ss'): null
      },

      search() {

        this.filtersError = false;

        if(!(this.getFilters().fromDate < this.getFilters().toDate)) {
          this.filtersError = true;
          return
        }
        this.filters = {
          ...this.getFilters(),
          offset: 0
        };

        this.isLoading = true;
        this.noResultsFound = false;
        this.disableLoadMore = false;
        this.$store.dispatch('sessions/list', this.filters)
          .then((sessionLogs) => {
            this.isLoading = false;
            if(sessionLogs.length === 0) {
              this.noResultsFound = true;
            }
          })
          .catch(() => {
            this.isLoading = false;
          })
      },

      duration(log) {
        if(log.initiatedAt && log.endedAt) {
          let durationInSecconds = differenceInSeconds(parseInt(log.endedAt), parseInt(log.initiatedAt));
          let hours = Math.floor(durationInSecconds / 3600);
          let secondsLeft = durationInSecconds - (hours * 3600);
          let minutes = Math.floor(secondsLeft / 60);
          let seconds = secondsLeft - (minutes * 60);

          let duration = '';
          if(hours) {
            duration += `${hours} hour${hours > 1? 's': ''} `
          }

          if(minutes) {
            duration += `${minutes} min `
          }

          if(seconds) {
            duration += `${seconds} sec`
          }

          return duration;
        } else {
          return null
        }
      },

      getFilters() {
        let fromDate = setSeconds(setMinutes(setHours(this.filters.fromDate, 0), 0), 0);
        let toDate = setSeconds(setMinutes(setHours(this.filters.toDate, 23), 59), 59);
        return {
          ...this.filters,
          fromDate,
          toDate,
          contactId: this.contact ? this.contact.id: null
        }
      },

      loadMore() {
        if(this.isLoading || this.disableLoadMore) {
          return
        }
        this.isLoading = true;
        this.filters = {
          ...this.getFilters(),
          offset: this.sessionLogs.length
        };

        this.$store.dispatch('sessions/loadMore', this.filters)
          .then((logs) => {
            this.isLoading = false;
            if(logs.length === 0) {
              this.disableLoadMore = true
            }
          })
          .catch(() => {
            this.isLoading = false;
          })
      },

      isActiveSort(col) {
        return this.filters.order && this.filters.order[0] === col
      },

      isSortDesc(col) {
        let order = this.filters.order;
        if(order && order[0] === col) {
          return order[1] === 'DESC'
        } else {
          return true
        }
      },

      sortBy(col) {
        let order = this.filters.order;
        if(order && order[0] === col) {
          let isAsc = order[1] === 'ASC';
          this.filters = {
            ...this.filters,
            order: [col, isAsc? 'DESC': 'ASC']
          };
        } else {
          this.filters = {
            ...this.filters,
            order: [col, 'DESC']
          }
        }

        this.search()
      },

      openScreenshotsPreview(session) {
        this.currentScreenshotsSessionLog = session;
      },

      closeScreenshotsPreview() {
        this.currentScreenshotsSessionLog = null;
      },

      openNotesPreview(session) {
        this.currentNotesSessionLog = session;
      },

      closeNotesPreview() {
        this.currentNotesSessionLog = null;
      },

      openCallDetailsPreview(session) {
        this.currentSessionCallDetails = session;
      },

      closeCurrentSessionCallDetailsPreview() {
        this.currentSessionCallDetails = null
      },

      getLogPlatform(platform) {
        if(!platform || platform === 'IOS') {
          return 'iOS'
        } else {
          return 'Android'
        }
      }
    },

    created() {
      this.search()
    }
  }
</script>

<style lang="scss">
@import "SessionLogs";
</style>
